/**
 * Target of the approved "App'e dön" sidebar link (Console v2.dc.html:63-66). It is configured per environment through
 * the optional VITE_APP_URL; an absent, malformed or non-http(s) value never becomes a link target, so the link stays inert.
 */
export function appReturnHref(value: string | undefined = import.meta.env.VITE_APP_URL): string | undefined {
  const raw = value?.trim()
  if (!raw) return undefined
  try {
    const url = new URL(raw)
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined
  } catch {
    // A malformed optional target is treated exactly like an absent one.
    return undefined
  }
}
